import { isNull, isUndefined } from 'lodash-es';
import type { ReactNode } from 'react';

import Colors from '@dynatrace/strato-design-tokens/colors';

import { replaceSlashedZero } from '../../core/typographyStyles.sty.js';
import { useDefaultLabels } from '../hooks/useDefaultLabels.js';
import { useGaugeChartLabelsContext } from '../hooks/useGaugeChartLabelsContext.js';
import { useGaugeChartMinMaxLabelsPosition } from '../hooks/useGaugeChartMinMaxLabelsPosition.js';
import { GaugeLabel } from './GaugeLabel/GaugeLabel.js';
import { GaugeLabelsWrapper } from './GaugeLabelsWrapper/GaugeLabelsWrapper.js';

interface GaugeLabelsProps {
  value: number;
  prefixIcon?: ReactNode;
}

export const GaugeLabels = ({ value, prefixIcon }: GaugeLabelsProps) => {
  const { label } = useGaugeChartLabelsContext();

  const { defaultLabel, defaultMaxLabel, defaultMinLabel, defaultValueLabel } =
    useDefaultLabels(value);

  const { maxLabelPosition, minLabelPosition, minMaxPadding } =
    useGaugeChartMinMaxLabelsPosition();

  return (
    <>
      <g
        fill={Colors.Text.Neutral.Default}
        id="internal-labels"
        className={replaceSlashedZero}
      >
        <GaugeLabelsWrapper>
          <GaugeLabel
            id="value-label"
            value={defaultValueLabel}
            prefixIcon={prefixIcon}
            responsive
          />
          {!isUndefined(label) && (
            <GaugeLabel
              id="label"
              value={isNull(label) ? defaultLabel : label}
              responsive
            />
          )}
        </GaugeLabelsWrapper>
      </g>

      <g fill={Colors.Text.Neutral.Default} id="min-max-labels">
        <GaugeLabel
          value={defaultMinLabel}
          x={minLabelPosition.x}
          y={minLabelPosition.y + minMaxPadding}
          autoHide
        />
        <GaugeLabel
          value={defaultMaxLabel}
          x={maxLabelPosition.x}
          y={maxLabelPosition.y + minMaxPadding}
          autoHide
        />
      </g>
    </>
  );
};
